import React from "react";
import "./new-arrival-card.css";
import { Link } from "react-router-dom";
import Favourite_icon from "../../common-components/favourite-icon/Favourite_icon";
import { encodeId } from "../../../utils/common";

const TryOnIcon = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M8 3H5a2 2 0 0 0-2 2v3" />
    <path d="M16 3h3a2 2 0 0 1 2 2v3" />
    <path d="M8 21H5a2 2 0 0 1-2-2v-3" />
    <path d="M16 21h3a2 2 0 0 0 2-2v-3" />
    <circle cx="12" cy="12" r="3" />
  </svg>
);

const New_arrival_card = (props) => {
  const variants = props.variants || [];

  return (
    <section className="New_arrival_card">
      <div className="nac_inner">
        <div className="nac_top_row">
          <div className="nac_wishlist">
            <Favourite_icon id={props?.id} />
          </div>
          {props?.vto_enable && (
            <button
              className="nac_tryon"
              onClick={(e) => {
                e.preventDefault();
                props.setSelectedProduct();
              }}
            >
              <TryOnIcon />
              Try on
            </button>
          )}
        </div>

        <Link to={`/product-descrption/${encodeId(props?.id)}`} className="nac_image_link">
          <img
            className="nac_image"
            src={process.env.REACT_APP_IMAGE_URL + props.image}
            alt={props.name || "Eyewear frame"}
          />
        </Link>

        <div className="nac_content">
          <div className="nac_title_row">
            {props.name && <p className="nac_name">{props.name}</p>}
            <p className="nac_price">
              {props.prise}
              {props.oldprise && <span className="nac_oldprise">{props.oldprise}</span>}
            </p>
          </div>

          {variants.length > 0 && (
            <div className="nac_swatches">
              {variants.slice(0, 6).map((variant, idx) => {
                const first = variant?.Colour?.first_color;
                const second = variant?.Colour?.second_color;
                const swatchImage = variant?.Colour?.image;
                const background = first && second
                  ? `linear-gradient(90deg, ${first} 50%, ${second} 50%)`
                  : first
                  ? first
                  : swatchImage
                  ? `url(${process.env.REACT_APP_IMAGE_URL + swatchImage}) center/cover`
                  : "#e7eaf0";
                return (
                  <span
                    key={variant.id}
                    className={`nac_swatch${idx === 0 ? " active" : ""}`}
                    style={{ background }}
                    title={variant?.Colour?.name || ""}
                  />
                );
              })}
            </div>
          )}

          <Link to={`/product-descrption/${encodeId(props?.id)}`} className="nac_buy_btn">
            Select lenses and buy
          </Link>
        </div>
      </div>
    </section>
  );
};

export default New_arrival_card;